module.exports = __webpack_public_path__ + "img/dice_screen.0350e0fd.png";